import './job-detail-external';
import {init as jobAlertInit} from './job-detail-alert';
import config from './config.json';

const loadRecommendations = async () => {
	const recommendedVacanciesElem = document.getElementById("recommended-vacancies");
	const vacancyId = recommendedVacanciesElem.getAttribute("vacancy-id");
	const response = await fetch(`${config.basepath}/recommendations/${vacancyId}`);

	if (response.ok) {
		recommendedVacanciesElem.innerHTML = await response.text();
	}
}

const bindBackButtonClick = () => {
	const backButton = document.querySelector(`[href="#back"]`);

	if (!backButton)
		return;

	backButton.addEventListener("click", (e) => {
		e.preventDefault();

		if (window.history.length <= 1) {
			// Fallback for new tab
			window.location = e.target.dataset.overviewUrl;
		} else {
			window.history.back();
		}
	});
}

const init = async () => {
	bindBackButtonClick();
	await jobAlertInit();
	await loadRecommendations();
}

await init();
